export const VisitTypeWithName = [{ id: 0, name: 'On Site' }, { id: 1, name: 'Phone Call' }];
